import { memo, type CSSProperties } from 'react';

import socialCoinPile from '../../assets/coin/gc_pile.png';
import socialCoinPileWebp from '../../assets/coin/gc_pile.webp';
import socialCoinPng from '../../assets/social_coin.png';
import socialCoinWebp from '../../assets/social_coin_2x.webp';

export const SocialCoin = memo(
  ({
    className,
    style,
    alt,
    isPile,
  }: {
    className?: string;
    style?: CSSProperties;
    alt?: string;
    isPile?: boolean;
  }) => {
    return (
      <picture className={className} style={{ display: 'flex', ...style }}>
        <source srcSet={isPile ? socialCoinPileWebp : socialCoinWebp} type="image/webp" />
        <source srcSet={isPile ? socialCoinPile : socialCoinPng} type="image/png" />
        <img alt={alt || 'Social Coin'} src={isPile ? socialCoinPile : socialCoinPng} />
      </picture>
    );
  },
);

SocialCoin.displayName = 'SocialCoin';
